import { render, staticRenderFns } from "./GoodsCon_sole.vue?vue&type=template&id=25ad79b7&scoped=true&"
import script from "./GoodsCon_sole.vue?vue&type=script&lang=js&"
export * from "./GoodsCon_sole.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCon_sole.vue?vue&type=style&index=0&id=25ad79b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ad79b7",
  null
  
)

export default component.exports